// extracted by mini-css-extract-plugin
module.exports = {"content":"ProjectInsightsFrequency-module_content__39e8XJksXSm3Sv9ydjzpgb","csvDownloadWrap":"ProjectInsightsFrequency-module_csvDownloadWrap__aO8tLgXI6x0p7-Cps6iii"};